import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createAccountActions } from './account.actions'
import { accountInitialState } from './account.slice'
import type { AccountStore } from './account.type'

export const useAccountStore = create<AccountStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...accountInitialState,
        ...createAccountActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.AccountSettings,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
